document.addEventListener("DOMContentLoaded", (event) => {
	/**
	 * Prevent Default behaviour of links
	 */
	const hasPreventDefault = document.querySelectorAll(".prevent-default");
	if (hasPreventDefault && hasPreventDefault.length > 0) {
		hasPreventDefault.forEach((item) => {
			link = item.querySelector("a");
			if (link) link.addEventListener("click", (e) => e.preventDefault());
		});
	}

	const siteHeader = document.querySelector(".site-header");
	if (siteHeader) {
		const nav = siteHeader.querySelector(" & > nav");
		const toggleBtn = siteHeader.querySelector(".mobile-menu-toggler");
		const menuContainer = siteHeader.querySelector("#main-menu-container");
		const mainMenu = siteHeader.querySelector("#menu-main-menu");

		// Toggle mobile btn
		toggleBtn.addEventListener("click", toggleMobileNav.bind({ toggleBtn, menuContainer }));
		// Expanded Submenu Items on click
		mainMenu.addEventListener("click", expandSubMenuItem.bind({ mainMenu }));

		// Close the Mobile and sub menus if we click outside the header
		document.addEventListener("click", function (e) {
			if (!siteHeader.contains(e.target)) {
				// Close Mobile Menu
				toggleBtn.setAttribute("aria-expanded", false);
				menuContainer.classList.remove("expanded");

				// Close sub menus
				const subMenus = siteHeader.querySelectorAll(" .sub-menu");
				subMenus.forEach((menu) => {
					menu.classList.remove("expanded");
					const links = menu.querySelectorAll(" & > li > a");
					const subMenuDropdownBtns = menu.querySelectorAll(" & > li > .dropdown-icon");
					links.forEach((link) => link.setAttribute("tabindex", -1));
					subMenuDropdownBtns.forEach((icon) => icon.setAttribute("tabindex", 0));
				});
			}
		});

		/**
		 * Check if Header Nav is wrapped
		 */
		const navMenu = siteHeader.querySelector(".menu-wrapper");
		const navItems = siteHeader.querySelectorAll("#menu-main-menu > li ");
		const resizeObserver = new ResizeObserver((entries) => {
			const viewportWidth = window.innerWidth;

			if (viewportWidth > 767) {
				for (let entry of entries) {
					if (entry.target === siteHeader) {
						let hasWrapped = false;
						siteHeader.classList.remove("header-mobile");
						const navItemTop = navItems[0].offsetTop;
						// console.log(navItemTop);
						navItems.forEach((item) => {
							if (item.offsetTop !== navItemTop) {
								hasWrapped = true;
							}
						});

						// console.log(hasWrapped);
						if (hasWrapped) {
							siteHeader.classList.add("header-mobile");
						} else {
							siteHeader.classList.remove("header-mobile");
						}
					}
				}
			} else {
				siteHeader.classList.remove("header-mobile");
			}
		});
		resizeObserver.observe(siteHeader);
	}

	/**
	 * Add Bg when fixed nav is scrolled
	 */
	if (siteHeader) {
		window.addEventListener("scroll", function () {
			if (window.scrollY >= siteHeader.offsetHeight) {
				siteHeader.classList.add("add-sticky");
			} else {
				siteHeader.classList.remove("add-sticky");
			}
		});
	}
});

/**
 *
 * Mobile Menu toggle
 */
function toggleMobileNav(e) {
	e.preventDefault();
	const { toggleBtn: btn, menuContainer } = this;
	btn.classList.toggle("expanded");

	if (btn.classList.contains("expanded")) {
		btn.setAttribute("aria-expanded", true);
		menuContainer.classList.add("expanded");
	} else {
		btn.setAttribute("aria-expanded", false);
		menuContainer.classList.remove("expanded");
	}
}

/**
 *
 * @param {*} e
 * Expand submenu items
 */
function expandSubMenuItem(e) {
	const { mainMenu } = this;
	if (e.target.classList.contains("dropdown-icon")) {
		const parentLi = e.target.closest("li");
		const subMenu = e.target.nextElementSibling;
		const links = subMenu.querySelectorAll(" & > li > a");
		const subMenuDropdownBtn = subMenu.querySelectorAll(" & > li > .dropdown-icon");
		// console.log(subMenu);
		e.target.classList.toggle("expanded");
		if (e.target.classList.contains("expanded")) {
			e.target.setAttribute("aria-expanded", true);
			subMenu.classList.add("expanded");
			// subMenu.setAttribute("tabindex", 0);

			links.forEach((link) => link.setAttribute("tabindex", 0));
			subMenuDropdownBtn.forEach((icon) => icon.setAttribute("tabindex", 0));
		} else {
			e.target.setAttribute("aria-expanded", false);
			subMenu.classList.remove("expanded");
			// subMenu.setAttribute("tabindex", -1);
			links.forEach((link) => link.setAttribute("tabindex", -1));
			subMenuDropdownBtn.forEach((icon) => icon.setAttribute("tabindex", 0));
		}
	}
}
